<agr-page-toolbar
  [pageTitle]="pageTitle$ | async"
  [hasPrimaryAction]="false"
  class="technical-result"
>
  <div class="wrapper--spacing-all">
    <div class="flex--justify-space-between space--margin-bottom">
      <h2 class="text--h3"></h2>
      <app-month-picker
        (dateChanged)="onDateChanged($event)"
        [validDateFrom]="validDateFrom"
        [validDateTo]="validDateTo"
      ></app-month-picker>
    </div>

    <div class="spacing--margin-bottom table-desktop">
      @if (hasData()) {
        <table
          mat-table
          #table
          [dataSource]="dataSource"
          class="table-desktop__table--alternate-rows cust-table"
        >
          @for (column of columnIds(); track column; let colIndex = $index) {
            <ng-container matColumnDef="{{ column }}">
              <th mat-header-cell *matHeaderCellDef>
                <div
                  [class]="{
                    'text--right': allignRight(columns[colIndex].type),
                  }"
                >
                  <div class="flex--column">
                    <div>
                      {{ columns[colIndex].label | translate }}
                    </div>
                    @if (colIndex === 1) {
                      <div>
                        <div>&nbsp;</div>
                        <div>{{ columns[colIndex].dateFrom | date: 'MMM-YY' }}</div>
                      </div>
                    }
                    @if (colIndex > 1) {
                      <div>
                        <div>{{ columns[colIndex].dateFrom | date: 'MMM-YY' }}</div>
                        <div>{{ columns[colIndex].dateTo | date: 'MMM-YY' }}</div>
                      </div>
                    }
                  </div>
                </div>
              </th>
              <td mat-cell *matCellDef="let row" [class]="{ 'mat-column-number': colIndex > 0 }">
                @if (colIndex === 0) {
                  <div>
                    {{ 'technical-result.column.' + row[column] | translate }}
                  </div>
                }
                @if (colIndex !== 0 && !row.isHeader) {
                  <div>
                    {{ row[column] | number: row.format }}
                  </div>
                }
              </td>
            </ng-container>
          }
          <tr mat-header-row *matHeaderRowDef="columnIds()"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: columnIds()"
            [class]="row.isHeader ? 'sub-header' : ''"
          ></tr>
        </table>
      }
    </div>
    <agr-notification-empty
      [isEmpty]="!hasData()"
      [emptyTitle]="'no_items' | translate"
      emptyImage="/assets/images/no-items.png"
      class="complete__notification-empty"
    >
    </agr-notification-empty>
  </div>
</agr-page-toolbar>
